import {QUOTE_FROZEN_STATES} from "v4/data/quoteStates";
import useAccessVoter from "v4/hooks/useAccessVoter";

export default function QuoteVoter() {
    const { hasRole } = useAccessVoter();

    const canReofferQuote = (currentState) => {
        if (!currentState) return false;

        return hasRole('QUOTE_REGENERATE_PRICES') && !QUOTE_FROZEN_STATES.includes(currentState);
    }

    return ({ canReofferQuote });
}
